export default () => ({

    active: 0,
    duration: 3000,
    total: null,
    
    start() {
        setInterval(() => {
            this.nextSlide();
        }, this.duration);
    },

    nextSlide() {
        if(this.active == this.total) {
            this.active = 0;
        } else {
            this.active = this.active + 1;
        }
    }

})